import React, { useEffect, useState } from 'react'
import { Stack, Heading, Text, Input, Button, ReadOnlyCopyInput, FormControl } from '@/components/lib'
import QrCode from '@/components/includes/QrCode'
import utils from '../../utils/utils'
import api from '../../api'

// Set up - or replace - the authenticator app on the signed-in account.
// Fetches a fresh secret on mount, shows it as a QR code, and verifies the
// first code from the new device. Used from the security settings page and
// from the enrolment screen a password account sees before its first login
// with no second factor.
//
// `replacing`: the account already has a working authenticator. The API then
// needs the password as well before it will switch to the new secret, so a
// password field is shown.
// `onComplete(data)`: called with the API response. During enrolment that
// carries the account's new full session token.
export default function AuthenticatorSetup ({ replacing, onComplete }) {
  const [otpUri, setOtpUri] = useState('')
  const [otpSecret, setOtpSecret] = useState('')
  const [otpCode, setOtpCode] = useState('')
  const [password, setPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    api.accounts.getOtpUri(data => {
      setOtpUri(data.uri)
      setOtpSecret(data.secret)
    }, err => utils.toast('error', err.message))
  }, [])

  function verify (e) {
    e?.preventDefault?.()
    setSubmitting(true)
    api.accounts.enableOtp(otpCode, replacing ? password : null, data => {
      setSubmitting(false)
      onComplete && onComplete(data)
    }, err => {
      setSubmitting(false)
      utils.toast('error', err.message)
    })
  }

  return (
    <Stack as='form' gap={5} onSubmit={verify}>
      <Stack bg='bg.surface' p={3} rounded='md'>
        <Heading size='sm' as='h5'>1. Configure your authenticator app or device</Heading>
        <Text>Scan the QR code below using your authenticator app.</Text>
        {otpUri && <QrCode name='Trialflare' url={otpUri} size={200} />}
        <Text>If your app or device can't read the QR code, you can use the following text code instead:</Text>
        <ReadOnlyCopyInput value={otpSecret} size='sm' />
      </Stack>
      <Stack bg='bg.surface' p={3} rounded='md'>
        <Heading size='sm' as='h5'>2. Verify your set-up</Heading>
        <Text>Now, enter the six-digit code generated by your authenticator app or device to verify the set-up.</Text>
        <Input autoFocus inputMode='numeric' autoComplete='one-time-code' placeholder='123456' value={otpCode} onChange={e => setOtpCode(e.target.value)} />
        {replacing &&
          <FormControl label='Your account password' helperText='Needed to switch your account to the new authenticator. Your current one keeps working until this is verified.'>
            <Input type='password' autoComplete='current-password' value={password} onChange={e => setPassword(e.target.value)} />
          </FormControl>}
      </Stack>

      <Button type='submit' colorPalette='primary' isLoading={submitting}>Complete setup</Button>
    </Stack>
  )
}
